module.exports = __webpack_public_path__ + "img/ali_pay.b8a9f13e.png";